import React from "react";
import { useTeamContext } from "store/contexts/teamContext";

const styles = {
  root: {
    backgroundColor: "#000",
    color: "white",
    height: "300px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "10px",
  },
  goto: {
    cursor: "pointer",
    fontSize: "14px",
    paddingTop: "5px",
    fontWeight: 600,
    color: "#a1a2a9",
  },
};

export default () => {
  const { team } = useTeamContext();
  const classes = styles;

  const gotoBrowser = () => {
    window.open(
      `https://reteam.beremote.com/teams/${team?.id}/timeline`,
      "_black"
    );
  };

  return (
    <div style={classes.root}>
      <span>Please go to our website to record the screen</span>
      <span style={classes.goto} onClick={gotoBrowser}>
        https://reteam.beremote.com/teams/{team?.id}/timeline
      </span>
    </div>
  );
};
